"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var Roku = function Roku() {
  return _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M-127.3,425h-143.1v-74.6h143.1V425z M-235.3,390.9c0,3-2.4,5.4-5.4,5.4h-2.7v-10.8h2.7  C-237.7,385.4-235.3,387.9-235.3,390.9 M-223.1,412.5l-9.1-12.7c3.4-2,5.6-5.2,5.6-8.9c0-6-5.8-10.8-12.9-10.8h-12.4v32.4h8.6v-10.8  h2.6l7.8,10.8H-223.1 M-213.4,392.8c2.3,0,4.3,3.1,4.3,6.9c0,3.8-1.9,6.9-4.3,6.9c-2.3,0-4.2-3.1-4.2-6.9S-215.7,392.8-213.4,392.8   M-200.1,399.8c0-7.3-6-13.2-13.3-13.2c-7.3,0-13.2,5.9-13.2,13.2c0,7.3,5.9,13.2,13.2,13.2C-206.1,413-200.1,407.1-200.1,399.8   M-142.7,387.3c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2C-140.7,388.2-141.6,387.3-142.7,387.3z M-142.7,387.7  c0.9,0,1.5,0.7,1.5,1.6c0,0.9-0.6,1.6-1.5,1.6c-0.9,0-1.5-0.7-1.5-1.6C-144.3,388.4-143.6,387.7-142.7,387.7z M-143,389.5h0.2  c0.3,0,0.4,0.1,0.4,0.3c0.1,0.2,0.1,0.4,0.2,0.5h0.5c0-0.1-0.1-0.2-0.1-0.5c-0.1-0.3-0.2-0.4-0.4-0.5v0c0.2-0.1,0.4-0.2,0.4-0.5  c0-0.2-0.1-0.3-0.2-0.4c-0.1-0.1-0.3-0.1-0.7-0.1c-0.3,0-0.6,0-0.8,0.1v2h0.5V389.5z M-143,388.6c0,0,0.1,0,0.3,0  c0.3,0,0.4,0.1,0.4,0.3c0,0.2-0.2,0.3-0.5,0.3h-0.2V388.6z M-154.7,387.1v13.2v3.2c-1,1.7-2.3,2.8-4.4,2.8c-2.1,0-3.1-1.3-3.1-5.3  v-1.1v-12.8h-17.7l-9.9,10v-10h-8.6v25.4h8.6v-10.3l10.4,10.3h10.9l-13.2-13.2l10.9-10.9v15.1c0,5,3,9.6,10.6,9.6  c3.6,0,6.9-2,8.5-3.9l3.9,3.3h1.8v-25.3H-154.7z"
  }));
};

Roku.displayName = 'Roku';
var _default = Roku;
exports["default"] = _default;
Roku.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Roku"
};

if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Roku.js"] = {
    name: "Roku",
    docgenInfo: Roku.__docgenInfo,
    path: "src/Roku.js"
  };
}